// Utility for handling session expiration
let sessionExpiredHandled = false;

export const handleSessionExpired = (callback?: () => void) => {
  if (sessionExpiredHandled) {
    return; // Already handled, don't show multiple messages
  }
  
  sessionExpiredHandled = true;
  
  // Clear token
  localStorage.removeItem('token');
  
  // Show message and redirect after delay
  setTimeout(() => {
    window.location.href = '/auth/auth';
  }, 2000);
  
  // Execute callback if provided
  if (callback) {
    callback();
  }
};

// Reset the flag when user logs in (call this in login success)
export const resetSessionExpiredFlag = () => {
  sessionExpiredHandled = false;
};

// Check if session expired is already handled
export const isSessionExpiredHandled = () => {
  return sessionExpiredHandled;
};

// React hook for easier usage in components
import { useCallback } from 'react';

export const useSessionHandler = () => {
  const handleSessionExpiredWithMessage = useCallback((message: string) => {
    handleSessionExpired(() => {
      // You can use any notification system here
      console.log(message);
    });
  }, []);

  return {
    handleSessionExpired: handleSessionExpiredWithMessage,
    isSessionExpiredHandled,
  };
}; 